import { readUserTagName } from "../../../components/Events/Event/Applicants/eventRequestMappers";
import { applicantsProfileStatus, genders } from "../../../utils/Constants";
import { EMPTY_VALUE } from "./constants";

export const hasActiveApplicantsFilters = (filterState) =>
  Boolean(
    filterState.searchValue?.trim() ||
      filterState.profile_status ||
      filterState.is_assigned_to_event != null ||
      filterState.gender ||
      filterState.height ||
      filterState.age ||
      filterState.weight ||
      filterState.role_id ||
      filterState.language_id ||
      filterState.chronic_disease_id ||
      filterState.disability_id ||
      filterState.nationality_id ||
      filterState.city_id ||
      filterState.speaking_proficiency ||
      filterState.tag_id ||
      filterState.favourite_company_id ||
      (filterState.working_shift && filterState.working_shift !== ""),
  );

export const getApplicantsStaticFilterOptions = (applicants) => ({
  profileStatusOptions: [
    {
      id: 1,
      name: applicants.listApplicants.verified,
      value: applicantsProfileStatus.verified,
    },
    {
      id: 2,
      name: applicants.listApplicants.profile_completed,
      value: applicantsProfileStatus.profileCompleted,
    },
    {
      id: 3,
      name: applicants.listApplicants.basic_profile_completed,
      value: applicantsProfileStatus.basicProfileCompleted,
    },
  ],
  applicantStatusOptions: [
    { id: 1, name: applicants.listApplicants.assigned, value: true },
    { id: 2, name: applicants.listApplicants.notAssigned, value: false },
  ],
  genderOptions: [
    {
      id: 1,
      name: applicants.listApplicants.notProvided,
      value: genders.notProvided,
    },
    { id: 2, name: applicants.listApplicants.male, value: genders.male },
    { id: 3, name: applicants.listApplicants.female, value: genders.female },
  ],
  ageOptions: [
    { id: 1, name: applicants.listApplicants.ageRange1, value: [16, 25] },
    { id: 2, name: applicants.listApplicants.ageRange2, value: [25, 30] },
    { id: 3, name: applicants.listApplicants.ageRange3, value: [30, 35] },
    { id: 4, name: applicants.listApplicants.ageRange4, value: [35, 40] },
  ],
  weightOptions: [
    { id: 1, name: applicants.listApplicants.weightRange1, value: [40, 50] },
    { id: 2, name: applicants.listApplicants.weightRange2, value: [50, 70] },
    { id: 3, name: applicants.listApplicants.weightRange3, value: [70, 100] },
    { id: 4, name: applicants.listApplicants.weightRange4, value: [100, 120] },
    { id: 5, name: applicants.listApplicants.weightRange5, value: [120, 170] },
  ],
  heightOptions: [
    { id: 1, name: applicants.listApplicants.heightRange1, value: [140, 160] },
    { id: 2, name: applicants.listApplicants.heightRange2, value: [160, 180] },
    { id: 3, name: applicants.listApplicants.heightRange3, value: [180, 200] },
    { id: 4, name: applicants.listApplicants.heightRange4, value: [200, 300] },
  ],
});

export const mapApplicantsToTableRows = (list, { lang, shared, applicants }) =>
  list.map((row) => ({
    id: row.id,
    name: {
      data:
        lang === "en" && row.full_name_en.trim()
          ? row.full_name_en
          : lang === "ar" && row.full_name_ar.trim()
            ? row.full_name_ar
            : "-",
      isBlocked: row.is_blocked,
    },
    nameText:
      lang === "en" && row.full_name_en.trim()
        ? row.full_name_en
        : lang === "ar" && row.full_name_ar.trim()
          ? row.full_name_ar
          : "-",
    nameEn: row.full_name_en?.trim() ? row.full_name_en.trim() : EMPTY_VALUE,
    nameAr: row.full_name_ar?.trim() ? row.full_name_ar.trim() : EMPTY_VALUE,
    isBlocked: row.is_blocked,
    email: row.email || "-",
    nationality: row.nationality?.name || "-",
    fieldsOfStudy: row.field_of_study?.name || "-",
    profileRate: row.rating,
    role: row.role?.name || "-",
    userId: row.id,
    userTag: row.user_tag || null,
    tagName: readUserTagName(row.user_tag, lang),
    city: row.city?.name || "-",
    age: row.age || "-",
    language: row.user_languages || [],
    gender: shared.genderOptions[row.gender] || "-",
    weight: row.weight ? `${row.weight} ${shared.kg}` : "-",
    height: row.height ? `${row.height} ${shared.cm}` : "-",
    profileStatus: applicants.listApplicants[row.profile_status] || "-",
    applicantStatus: row.participated_in_events_count
      ? applicants.listApplicants.assigned
      : applicants.listApplicants.notAssigned,
    disability: {
      data: row.disabilities || [],
      status: row.profile_status,
    },
    diseases: {
      data: row.chronic_diseases || [],
      status: row.profile_status,
    },
    profileStatusValue: row.profile_status,
    img: row.image,
  }));
